/**
 * Sheet R18 (Kelly): an EMPTY Container block was effectively invisible in the
 * Wheel Edit builder — a white fill inside a hairline, palette-tinted border on
 * a white canvas, so there was no way to tell the block had been added at all.
 *
 * This is the single decision the fix turns on, kept as a pure predicate so the
 * rule is testable without mounting craft.js: the empty-state placeholder is an
 * AUTHORING affordance only. It shows when the craft.js editor is enabled (the
 * builder) AND the Container holds no children. A visitor reading the published
 * Wheel (editor disabled) must never see it, and a Container that has content
 * never needs it.
 */
export const shouldShowEmptyPlaceholder = (isEditorEnabled, hasChildren) =>
  Boolean(isEditorEnabled) && !hasChildren;

export default shouldShowEmptyPlaceholder;
